import * as React from 'react';

/** Material UI Packages. */
import { TextField, Box, Typography } from '@mui/material';

/**
 * Reusable FormField component for displaying read-only form fields
 * @param {string} label - The label for the field
 * @param {string} value - The value to display
 * @param {string} type - The input type (default: 'text')
 * @param {boolean} multiline - Whether the field should be multiline
 * @param {number} rows - Number of rows for multiline fields
 * @param {object} sx - Additional styling
 * @returns {JSX.Element} FormField component
 */
export default function FormField({
    label,
    value = '',
    type = 'text',
    multiline = false,
    rows = 1,
    sx = {},
    textFieldStyle = {},
    readOnly = false,
    onChange = () => {},
}) {
    return (
        <Box sx={{ ...sx }}>
            <Typography
                sx={{
                    mb: 1,
                    fontWeight: 500,
                    fontSize: 13,
                    color: 'text.secondary',
                }}
            >
                {label}
            </Typography>
            <TextField
                fullWidth
                size="small"
                value={value}
                type={type}
                multiline={multiline}
                onChange={onChange}
                rows={multiline ? rows : undefined}
                slotProps={{
                    input: {
                        readOnly: readOnly,
                    },
                }}
                sx={{
                    '& .MuiInputBase-input': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        cursor: 'default',
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'rgba(0, 0, 0, 0.23)',
                        },
                        '&:hover fieldset': {
                            borderColor: 'rgba(0, 0, 0, 0.23)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'rgba(0, 0, 0, 0.23)',
                        },
                    },
                    ...textFieldStyle,
                }}
            />
        </Box>
    );
}
